export class Channel {
    gene: string;
    cpValue: number;
    geneResult: string;
    originalGeneResult: string;
    resultUploaded: boolean;

    constructor(gene: string) {
        this.gene = gene;
    }
}